import { HTMLStringRenderer } from '@components/common/HTMLStringRenderer'
import ClickOutside from '@utils/click-outside'
import { useDevice } from '@utils/responsiveness/useDevice'
import { ReactNode, useState } from 'react'

export function FormFieldTooltip({
  children,
  className,
  customLabel,
  snapToRight = false,
}: {
  customLabel?: ReactNode
  children: ReactNode | string
  className?: string
  snapToRight?: boolean
}) {
  const { isMobile } = useDevice()
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false)

  return (
    <div className={`relative inline-block select-none ${className}`}>
      {customLabel && (
        <button
          className={`text-acai select-none
            ${
              tooltipIsOpen
                ? 'pointer-events-none touch-none cursor-pointer'
                : 'pointer-events-auto'
            }`}
          onClick={() =>
            isMobile ? () => {} : setTooltipIsOpen(!tooltipIsOpen)
          }
          onTouchEnd={() =>
            isMobile ? setTooltipIsOpen(!tooltipIsOpen) : () => {}
          }
        >
          {customLabel}
        </button>
      )}

      {!customLabel && (
        <button
          className={`rounded-full w-[15px] h-[15px] bg-black-10 hover:bg-black-20 text-base p-2 pt-3 leading-none font-semibold cursor-pointer flex items-center justify-center ml-4 ${
            tooltipIsOpen
              ? 'pointer-events-none touch-none cursor-pointer'
              : 'pointer-events-auto'
          }`}
          onClick={() =>
            isMobile ? () => {} : setTooltipIsOpen(!tooltipIsOpen)
          }
          onTouchEnd={() =>
            isMobile ? setTooltipIsOpen(!tooltipIsOpen) : () => {}
          }
        >
          ?
        </button>
      )}

      <ClickOutside
        active={tooltipIsOpen}
        onClick={() => setTooltipIsOpen(false)}
      >
        <div
          className={`absolute text-acai px-6 py-4 bg-white rounded-lg w-max max-w-[220px] sm:max-w-[320px] bottom-[calc(100%+8px)] shadow-md font-mori ${
            tooltipIsOpen ? 'block' : 'hidden'
          } ${snapToRight ? 'right-0' : 'left-0'}`}
        >
          {typeof children === 'string' ? (
            <HTMLStringRenderer htmlString={children} />
          ) : (
            children
          )}
        </div>
      </ClickOutside>
    </div>
  )
}
